import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { fetchHot100Archive} from '~/features/actions';
const Hot100Archive = (props) => {
	const { dispatch, hot100Archive } = props;
	useEffect( () => {
		dispatch(fetchHot100Archive())
	}, [])

  const groupBy = (x,f)=>x.reduce((a,b,i)=>((a[f(b,i,x)]||=[]).push(b),a),{});

  const [ selectedYear, selectYear ]  = useState('2023');

  useEffect(() => {
    console.log('changed year')
    let randomHue = Math.floor(Math.random() * 256);
    let contrastHue = (randomHue + 161) % 255;

    console.log(randomHue, contrastHue)
    let archive = document.getElementById('hot100-archive');
    archive.style.setProperty(
      '--color-foreground',
      `hsla(${randomHue}, 79%, 63%, 0.8)`
    );
    archive.style.setProperty(
      '--color-background',
      `hsl(${contrastHue}, 39%, 63%)`
    );

  }, [selectedYear])

  if (hot100Archive.items.length > 0)  
  {
    const hot100ByYear = groupBy(hot100Archive.items, v => v.year );

    return (
      <div id='hot100-archive' style={{paddingBottom: '48px'}}>
        <h3>Hot 100 Archive</h3>
        <div className="years" style={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap'}}>
          { 
            Object.entries(hot100ByYear).map( ([year, items], n) => 
              <div key={n} onClick={() => selectYear(year) } className={year === selectedYear ? 'active' : ''} style={{ cursor: 'pointer'}}>{year}</div>
            )
          }
            <div style={{flex: 1, background: 'none'}}></div>
            <div className='download'><a href="https://4zzz.org.au/zzz/hot100-archive.json">JSON</a></div>
            <div className='download'><a href="https://4zzz.org.au/zzz/hot100-archive.csv">CSV</a></div>
          </div>
        <h4>{selectedYear}</h4>
        <table>
          <thead>
            <tr>
              {/* <td>{i.year}</td> */}
              <th>Rank</th>
              <th>Artist</th>
              <th>Title</th>
            </tr>
          </thead>
        { hot100ByYear[selectedYear].map( (i, n) => 
          <tbody key={n}>
            <tr>
              {/* <td>{i.year}</td> */}
              <td>{i.rank}</td>
              <td>{i.artist}</td>
              <td>{i.title}</td>
            </tr>
          </tbody>
        )}
        </table>
      </div>
    )
  }
  else { 
    return <div id='hot100-archive'>
      <h3>Hot 100 Archive</h3>
    </div>

  }
}

export default connect( state => ({ hot100Archive: state.hot100Archive })) (Hot100Archive)
